<template>
  <section class="bugallery">
    <div class="bugallery-wrapper py-5">
      <div class="container">
            <div class="d-flex justify-content-around row flex-wrap">
              <!-- For loop for looping over the videos. -->
            <div v-for="video in videos" :key="video">
              <youtube :video-id="video" ref="youtube"></youtube>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ec-business-video',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      title: 'Dit is het ec-business-video component.',
      apiKey: 'AIzaSyC3W2gGQHrRGadO5dd4K-peo2aqtc81duQ',
      videos: []
    }
  },
  mounted () {
    if (this.item.itemable.video_url.includes('/watch?v=')) {
      this.GetVideoFromUrl(this.item.itemable.video_url)
    }
    if (this.item.itemable.video_url.includes('/channel/')) {
      this.GetVideosFromChannel(/[^/]*$/.exec(this.item.itemable.video_url)[0])
    }
    if (this.item.itemable.video_url.includes('/user/')) {
      this.GetVideosFromUser(/[^/]*$/.exec(this.item.itemable.video_url)[0])
    }
    if (this.item.itemable.video_url.includes('/playlist/')) {
      this.GetVideosFromPlaylist(
        /[^/]*$/.exec(this.item.itemable.video_url)[0]
      )
    }
  },
  methods: {
    GetVideosFromPlaylist (playlist) {
      this.$http
        .get(
          `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=20&order=date&playlistId=${playlist}&key=${
            this.apiKey
          }`
        )
        .then(response => {
          // getting all videos from a playlist
          response.body.items.forEach(item => {
            if (item.id.kind === 'youtube#playlistItem') this.videos.push(item.snippet.resourceId.videoId)
          })
        })
    },
    GetVideosFromChannel (channel) {
      this.$http
        .get(
          `https://www.googleapis.com/youtube/v3/search?key=${
            this.apiKey
          }&channelId=${channel}&part=snippet,id&order=date&maxResults=20`
        )
        .then(response => {
          // getting all the videos for this channel
          response.body.items.forEach(item => {
            if (item.id.kind === 'youtube#playlist') this.GetVideosFromPlaylist(item.id.playlistId)
            if (item.id.kind === 'youtube#video') this.videos.push(item.id.videoId)
          })
        })
    },
    GetVideosFromUser (user) {
      this.$http
        .get(
          `https://www.googleapis.com/youtube/v3/channels?key=${
            this.apiKey
          }&forUsername=${user}&part=id&order=date&maxResults=20`
        )
        .then(response => {
          // finds all channels for the user then finds all videos
          response.body.items.forEach(item => {
            if (item.kind === 'youtube#channel') this.GetVideosFromChannel(item.id)
          })
        })
    },
    GetVideoFromUrl (url) {
      // regular expression extracts id from url.
      this.videos.push(url.match('v=([a-zA-Z0-9_-]+)&?')[1])
    }
  }
}
</script>
